module.exports = __webpack_public_path__ + "static/media/transfers-tooltip.db675670.svg";